<script setup lang="ts">
import BasicLayout from "../layouts/BasicLayout.vue";
import SignInContent from "./SignInContent.vue";
</script>

<template>
  <BasicLayout>
    <SignInContent></SignInContent>
  </BasicLayout>
</template>

<style scoped>

</style>
